import { render, staticRenderFns } from "./CurrencyChart.vue?vue&type=template&id=0fc1f24f&scoped=true"
import script from "./CurrencyChart.vue?vue&type=script&lang=js"
export * from "./CurrencyChart.vue?vue&type=script&lang=js"
import style0 from "./CurrencyChart.vue?vue&type=style&index=0&id=0fc1f24f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1f24f",
  null
  
)

export default component.exports